export default __webpack_public_path__ + "static/media/kl-05.2ac65abc.png";